var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArView = function SvgArView(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2350_17972",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 98
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2350_17972)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 49,
    r: 14,
    transform: "rotate(-180 76 49)",
    fill: "#FFE8C1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 81.5,
    r: 5.5,
    transform: "rotate(-180 35.5 81.5)",
    fill: "#E2D5F5",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M54.0851 79.8208L53.5598 80.634L54.0851 79.8208L46.5138 74.93L54.0851 70.0391L68 61.0505L81.9149 70.0391L89.4862 74.9299L81.9149 79.8208L68 88.8095L54.0851 79.8208ZM45.7178 75.4442L45.718 75.4441L45.7178 75.4442ZM68.1424 60.9585C68.1423 60.9585 68.1423 60.9586 68.1422 60.9586L68.1424 60.9585ZM67.8575 60.9584L67.8576 60.9585L67.8575 60.9584ZM90.2822 74.4157L90.282 74.4159L90.2822 74.4157Z",
    stroke: "url(#paint0_linear_2350_17972)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6299 59.9361V75.0634C80.6299 75.3055 80.5006 75.5292 80.2892 75.6573L68.3072 82.8987C68.1897 82.9676 68.059 83 67.9268 83C67.7902 82.9986 67.6537 82.9606 67.5347 82.8888L55.7098 75.6587C55.4984 75.5307 55.3706 75.3069 55.3706 75.0662V59.9333C55.3706 59.8151 55.4014 59.7011 55.4587 59.6011C55.516 59.4956 55.6026 59.4055 55.7098 59.3407L67.5347 52.1107C67.7741 51.9643 68.081 51.9629 68.3204 52.1079L80.2877 59.3407C80.3964 59.4055 80.483 59.4956 80.5418 59.6011C80.599 59.7025 80.6299 59.8179 80.6299 59.9361Z",
    fill: "#FF9584"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M67.9268 67.0958V83C67.7902 82.9985 67.6537 82.9605 67.5347 82.8888L55.7098 75.6587C55.4984 75.5306 55.3706 75.3068 55.3706 75.0661V59.9332C55.3706 59.815 55.4014 59.701 55.4587 59.6011L67.5347 66.9846C67.6537 67.0592 67.7902 67.0958 67.9268 67.0958Z",
    fill: "url(#paint1_linear_2350_17972)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M80.6298 59.936V75.0633C80.6298 75.3054 80.5006 75.5292 80.2891 75.6573L68.3071 82.8986C68.1896 82.9676 68.0589 83 67.9268 83V67.0958C68.0633 67.0958 68.1999 67.0606 68.3203 66.9874L80.5417 59.6011C80.599 59.7024 80.6298 59.8178 80.6298 59.936Z",
    fill: "url(#paint2_linear_2350_17972)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2350_17972",
    x1: 91,
    y1: 60,
    x2: 45,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2350_17972",
    x1: 67.9268,
    y1: 59.6011,
    x2: 55.3706,
    y2: 59.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2350_17972",
    x1: 80.6298,
    y1: 59.6011,
    x2: 67.9268,
    y2: 59.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arView.46f11c330ca4ffd1098f17a4dccd61f3.svg";